const MONTH_NAMES = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

const validDateParts = (year, month, day) => {
  const date = new Date(Date.UTC(year, month - 1, day));
  return date.getUTCFullYear() === year
    && date.getUTCMonth() === month - 1
    && date.getUTCDate() === day;
};

/**
 * Converts stored form dates into plain, ATS-readable resume dates without
 * changing the underlying value. Unknown formats are returned unchanged.
 */
export const formatResumeDate = (value) => {
  const text = String(value ?? '').trim();
  if (!text) return '';

  let match = text.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (match) {
    const [, yearText, monthText, dayText] = match;
    const year = Number(yearText);
    const month = Number(monthText);
    const day = Number(dayText);
    return validDateParts(year, month, day)
      ? `${MONTH_NAMES[month - 1]} ${day}, ${year}`
      : text;
  }

  match = text.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
  if (match) {
    const [, monthText, dayText, yearText] = match;
    const year = Number(yearText);
    const month = Number(monthText);
    const day = Number(dayText);
    return validDateParts(year, month, day)
      ? `${MONTH_NAMES[month - 1]} ${day}, ${year}`
      : text;
  }

  match = text.match(/^(\d{4})-(\d{2})$/);
  if (match) {
    const [, yearText, monthText] = match;
    const month = Number(monthText);
    return month >= 1 && month <= 12
      ? `${MONTH_NAMES[month - 1]} ${yearText}`
      : text;
  }

  return text;
};

export const formatResumeDateRange = (startDate, endDate, present = false) => {
  const start = formatResumeDate(startDate);
  const end = present ? 'Present' : formatResumeDate(endDate);

  if (start && end) return `${start} to ${end}`;
  return start || end;
};
